export default class ModelProto {

    // this is super dynamic model proto - not for entities but dynamic models
    // created just in case something need apply delta

    // but it's good idea to have this class


    public updatedFields: Set<string>

    constructor(data: any) {
        this.updatedFields  = new Set()
    }


    applyDelta(data:any) {

        _.forOwn(data, (value:any ,key:any)=>{
            if (key === 'id') return;

            // console.log("update key=", key, "value=", value)
            // console.log("this=", this);

            // @ts-ignore
            this[key] =  value;
        });

    }

    // just use this.updatedFeilds.clear();
    // resetUpdatedFields() {
    //     this.updatedFields = new Set();
    // }




}
